import { PendingEzshipOrdersListResponse } from '@/types/Reports';

export const frequencyList = [
  { value: '12', name: 'Days' },
  { value: '1', name: 'Weekly' },
  { value: '2', name: 'Biweekly' },
  { value: '3', name: 'Monthly' },
  { value: '4', name: 'Quarterly' },
  { value: '7', name: 'Bimonthly' },
  { value: '8', name: 'Every 4 Weeks' },
  { value: '9', name: 'Every 6 Weeks' },
  { value: '10', name: 'Every 8 Weeks' },
  { value: '11', name: 'Every 12 Weeks' },
];

export const daysList = [
  { value: '7', name: '7 Days' },
  { value: '8', name: '8 Days' },
  { value: '9', name: '9 Days' },
  { value: '10', name: '10 Days' },
  { value: '11', name: '11 Days' },
  { value: '12', name: '12 Days' },
  { value: '13', name: '13 Days' },
  { value: '14', name: '14 Days' },
  { value: '15', name: '15 Days' },
  { value: '16', name: '16 Days' },
  { value: '17', name: '17 Days' },
  { value: '18', name: '18 Days' },
  { value: '19', name: '19 Days' },
  { value: '20', name: '20 Days' },
  { value: '21', name: '21 Days' },
  { value: '22', name: '22 Days' },
  { value: '23', name: '23 Days' },
  { value: '24', name: '24 Days' },
  { value: '25', name: '25 Days' },
  { value: '26', name: '26 Days' },
  { value: '27', name: '27 Days' },
  { value: '28', name: '28 Days' },
  { value: '29', name: '29 Days' },
  { value: '30', name: '30 Days' },
  { value: '31', name: '31 Days' },
  { value: '32', name: '32 Days' },
  { value: '33', name: '33 Days' },
  { value: '34', name: '34 Days' },
  { value: '35', name: '35 Days' },
  { value: '36', name: '36 Days' },
  { value: '37', name: '37 Days' },
  { value: '38', name: '38 Days' },
  { value: '39', name: '39 Days' },
  { value: '40', name: '40 Days' },
  { value: '41', name: '41 Days' },
  { value: '42', name: '42 Days' },
  { value: '43', name: '43 Days' },
  { value: '44', name: '44 Days' },
  { value: '45', name: '45 Days' },
  { value: '46', name: '46 Days' },
  { value: '47', name: '47 Days' },
  { value: '48', name: '48 Days' },
  { value: '49', name: '49 Days' },
  { value: '50', name: '50 Days' },
  { value: '51', name: '51 Days' },
  { value: '52', name: '52 Days' },
  { value: '53', name: '53 Days' },
  { value: '54', name: '54 Days' },
  { value: '55', name: '55 Days' },
  { value: '56', name: '56 Days' },
  { value: '57', name: '57 Days' },
  { value: '58', name: '58 Days' },
  { value: '59', name: '59 Days' },
  { value: '60', name: '60 Days' },
  { value: '61', name: '61 Days' },
  { value: '62', name: '62 Days' },
  { value: '63', name: '63 Days' },
  { value: '64', name: '64 Days' },
  { value: '65', name: '65 Days' },
  { value: '66', name: '66 Days' },
  { value: '67', name: '67 Days' },
  { value: '68', name: '68 Days' },
  { value: '69', name: '69 Days' },
  { value: '70', name: '70 Days' },
  { value: '71', name: '71 Days' },
  { value: '72', name: '72 Days' },
  { value: '73', name: '73 Days' },
  { value: '74', name: '74 Days' },
  { value: '75', name: '75 Days' },
  { value: '76', name: '76 Days' },
  { value: '77', name: '77 Days' },
  { value: '78', name: '78 Days' },
  { value: '79', name: '79 Days' },
  { value: '80', name: '80 Days' },
  { value: '81', name: '81 Days' },
  { value: '82', name: '82 Days' },
  { value: '83', name: '83 Days' },
  { value: '84', name: '84 Days' },
  { value: '85', name: '85 Days' },
  { value: '86', name: '86 Days' },
  { value: '87', name: '87 Days' },
  { value: '88', name: '88 Days' },
  { value: '89', name: '89 Days' },
  { value: '90', name: '90 Days' },
  { value: '91', name: '91 Days' },
  { value: '92', name: '92 Days' },
  { value: '93', name: '93 Days' },
  { value: '94', name: '94 Days' },
  { value: '95', name: '95 Days' },
  { value: '96', name: '96 Days' },
  { value: '97', name: '97 Days' },
  { value: '98', name: '98 Days' },
  { value: '99', name: '99 Days' },
  { value: '100', name: '100 Days' },
  { value: '101', name: '101 Days' },
  { value: '102', name: '102 Days' },
  { value: '103', name: '103 Days' },
  { value: '104', name: '104 Days' },
  { value: '105', name: '105 Days' },
  { value: '106', name: '106 Days' },
  { value: '107', name: '107 Days' },
  { value: '108', name: '108 Days' },
  { value: '109', name: '109 Days' },
  { value: '110', name: '110 Days' },
  { value: '111', name: '111 Days' },
  { value: '112', name: '112 Days' },
  { value: '113', name: '113 Days' },
  { value: '114', name: '114 Days' },
  { value: '115', name: '115 Days' },
  { value: '116', name: '116 Days' },
  { value: '117', name: '117 Days' },
  { value: '118', name: '118 Days' },
  { value: '119', name: '119 Days' },
  { value: '120', name: '120 Days' },
  { value: '121', name: '121 Days' },
  { value: '122', name: '122 Days' },
  { value: '123', name: '123 Days' },
  { value: '124', name: '124 Days' },
  { value: '125', name: '125 Days' },
  { value: '126', name: '126 Days' },
  { value: '127', name: '127 Days' },
  { value: '128', name: '128 Days' },
  { value: '129', name: '129 Days' },
  { value: '130', name: '130 Days' },
  { value: '131', name: '131 Days' },
  { value: '132', name: '132 Days' },
  { value: '133', name: '133 Days' },
  { value: '134', name: '134 Days' },
  { value: '135', name: '135 Days' },
  { value: '136', name: '136 Days' },
  { value: '137', name: '137 Days' },
  { value: '138', name: '138 Days' },
  { value: '139', name: '139 Days' },
  { value: '140', name: '140 Days' },
  { value: '141', name: '141 Days' },
  { value: '142', name: '142 Days' },
  { value: '143', name: '143 Days' },
  { value: '144', name: '144 Days' },
  { value: '145', name: '145 Days' },
  { value: '146', name: '146 Days' },
  { value: '147', name: '147 Days' },
  { value: '148', name: '148 Days' },
  { value: '149', name: '149 Days' },
  { value: '150', name: '150 Days' },
  { value: '151', name: '151 Days' },
  { value: '152', name: '152 Days' },
  { value: '153', name: '153 Days' },
  { value: '154', name: '154 Days' },
  { value: '155', name: '155 Days' },
  { value: '156', name: '156 Days' },
  { value: '157', name: '157 Days' },
  { value: '158', name: '158 Days' },
  { value: '159', name: '159 Days' },
  { value: '160', name: '160 Days' },
  { value: '161', name: '161 Days' },
  { value: '162', name: '162 Days' },
  { value: '163', name: '163 Days' },
  { value: '164', name: '164 Days' },
  { value: '165', name: '165 Days' },
  { value: '166', name: '166 Days' },
  { value: '167', name: '167 Days' },
  { value: '168', name: '168 Days' },
  { value: '169', name: '169 Days' },
  { value: '170', name: '170 Days' },
  { value: '171', name: '171 Days' },
  { value: '172', name: '172 Days' },
  { value: '173', name: '173 Days' },
  { value: '174', name: '174 Days' },
  { value: '175', name: '175 Days' },
  { value: '176', name: '176 Days' },
  { value: '177', name: '177 Days' },
  { value: '178', name: '178 Days' },
  { value: '179', name: '179 Days' },
  { value: '180', name: '180 Days' },
  { value: '181', name: '181 Days' },
  { value: '182', name: '182 Days' },
  { value: '183', name: '183 Days' },
  { value: '184', name: '184 Days' },
  { value: '185', name: '185 Days' },
  { value: '186', name: '186 Days' },
  { value: '187', name: '187 Days' },
  { value: '188', name: '188 Days' },
  { value: '189', name: '189 Days' },
  { value: '190', name: '190 Days' },
  { value: '191', name: '191 Days' },
  { value: '192', name: '192 Days' },
  { value: '193', name: '193 Days' },
  { value: '194', name: '194 Days' },
  { value: '195', name: '195 Days' },
  { value: '196', name: '196 Days' },
  { value: '197', name: '197 Days' },
  { value: '198', name: '198 Days' },
  { value: '199', name: '199 Days' },
  { value: '200', name: '200 Days' },
  { value: '201', name: '201 Days' },
  { value: '202', name: '202 Days' },
  { value: '203', name: '203 Days' },
  { value: '204', name: '204 Days' },
  { value: '205', name: '205 Days' },
  { value: '206', name: '206 Days' },
  { value: '207', name: '207 Days' },
  { value: '208', name: '208 Days' },
  { value: '209', name: '209 Days' },
  { value: '210', name: '210 Days' },
  { value: '211', name: '211 Days' },
  { value: '212', name: '212 Days' },
  { value: '213', name: '213 Days' },
  { value: '214', name: '214 Days' },
  { value: '215', name: '215 Days' },
  { value: '216', name: '216 Days' },
  { value: '217', name: '217 Days' },
  { value: '218', name: '218 Days' },
  { value: '219', name: '219 Days' },
  { value: '220', name: '220 Days' },
  { value: '221', name: '221 Days' },
  { value: '222', name: '222 Days' },
  { value: '223', name: '223 Days' },
  { value: '224', name: '224 Days' },
  { value: '225', name: '225 Days' },
  { value: '226', name: '226 Days' },
  { value: '227', name: '227 Days' },
  { value: '228', name: '228 Days' },
  { value: '229', name: '229 Days' },
  { value: '230', name: '230 Days' },
  { value: '231', name: '231 Days' },
  { value: '232', name: '232 Days' },
  { value: '233', name: '233 Days' },
  { value: '234', name: '234 Days' },
  { value: '235', name: '235 Days' },
  { value: '236', name: '236 Days' },
  { value: '237', name: '237 Days' },
  { value: '238', name: '238 Days' },
  { value: '239', name: '239 Days' },
  { value: '240', name: '240 Days' },
  { value: '241', name: '241 Days' },
  { value: '242', name: '242 Days' },
  { value: '243', name: '243 Days' },
  { value: '244', name: '244 Days' },
  { value: '245', name: '245 Days' },
  { value: '246', name: '246 Days' },
  { value: '247', name: '247 Days' },
  { value: '248', name: '248 Days' },
  { value: '249', name: '249 Days' },
  { value: '250', name: '250 Days' },
  { value: '251', name: '251 Days' },
  { value: '252', name: '252 Days' },
  { value: '253', name: '253 Days' },
  { value: '254', name: '254 Days' },
  { value: '255', name: '255 Days' },
  { value: '256', name: '256 Days' },
  { value: '257', name: '257 Days' },
  { value: '258', name: '258 Days' },
  { value: '259', name: '259 Days' },
  { value: '260', name: '260 Days' },
  { value: '261', name: '261 Days' },
  { value: '262', name: '262 Days' },
  { value: '263', name: '263 Days' },
  { value: '264', name: '264 Days' },
  { value: '265', name: '265 Days' },
  { value: '266', name: '266 Days' },
  { value: '267', name: '267 Days' },
  { value: '268', name: '268 Days' },
  { value: '269', name: '269 Days' },
  { value: '270', name: '270 Days' },
  { value: '271', name: '271 Days' },
  { value: '272', name: '272 Days' },
  { value: '273', name: '273 Days' },
  { value: '274', name: '274 Days' },
  { value: '275', name: '275 Days' },
  { value: '276', name: '276 Days' },
  { value: '277', name: '277 Days' },
  { value: '278', name: '278 Days' },
  { value: '279', name: '279 Days' },
  { value: '280', name: '280 Days' },
  { value: '281', name: '281 Days' },
  { value: '282', name: '282 Days' },
  { value: '283', name: '283 Days' },
  { value: '284', name: '284 Days' },
  { value: '285', name: '285 Days' },
  { value: '286', name: '286 Days' },
  { value: '287', name: '287 Days' },
  { value: '288', name: '288 Days' },
  { value: '289', name: '289 Days' },
  { value: '290', name: '290 Days' },
  { value: '291', name: '291 Days' },
  { value: '292', name: '292 Days' },
  { value: '293', name: '293 Days' },
  { value: '294', name: '294 Days' },
  { value: '295', name: '295 Days' },
  { value: '296', name: '296 Days' },
  { value: '297', name: '297 Days' },
  { value: '298', name: '298 Days' },
  { value: '299', name: '299 Days' },
  { value: '300', name: '300 Days' },
  { value: '301', name: '301 Days' },
  { value: '302', name: '302 Days' },
  { value: '303', name: '303 Days' },
  { value: '304', name: '304 Days' },
  { value: '305', name: '305 Days' },
  { value: '306', name: '306 Days' },
  { value: '307', name: '307 Days' },
  { value: '308', name: '308 Days' },
  { value: '309', name: '309 Days' },
  { value: '310', name: '310 Days' },
  { value: '311', name: '311 Days' },
  { value: '312', name: '312 Days' },
  { value: '313', name: '313 Days' },
  { value: '314', name: '314 Days' },
  { value: '315', name: '315 Days' },
  { value: '316', name: '316 Days' },
  { value: '317', name: '317 Days' },
  { value: '318', name: '318 Days' },
  { value: '319', name: '319 Days' },
  { value: '320', name: '320 Days' },
  { value: '321', name: '321 Days' },
  { value: '322', name: '322 Days' },
  { value: '323', name: '323 Days' },
  { value: '324', name: '324 Days' },
  { value: '325', name: '325 Days' },
  { value: '326', name: '326 Days' },
  { value: '327', name: '327 Days' },
  { value: '328', name: '328 Days' },
  { value: '329', name: '329 Days' },
  { value: '330', name: '330 Days' },
  { value: '331', name: '331 Days' },
  { value: '332', name: '332 Days' },
  { value: '333', name: '333 Days' },
  { value: '334', name: '334 Days' },
  { value: '335', name: '335 Days' },
  { value: '336', name: '336 Days' },
  { value: '337', name: '337 Days' },
  { value: '338', name: '338 Days' },
  { value: '339', name: '339 Days' },
  { value: '340', name: '340 Days' },
  { value: '341', name: '341 Days' },
  { value: '342', name: '342 Days' },
  { value: '343', name: '343 Days' },
  { value: '344', name: '344 Days' },
  { value: '345', name: '345 Days' },
  { value: '346', name: '346 Days' },
  { value: '347', name: '347 Days' },
  { value: '348', name: '348 Days' },
  { value: '349', name: '349 Days' },
  { value: '350', name: '350 Days' },
  { value: '351', name: '351 Days' },
  { value: '352', name: '352 Days' },
  { value: '353', name: '353 Days' },
  { value: '354', name: '354 Days' },
  { value: '355', name: '355 Days' },
  { value: '356', name: '356 Days' },
  { value: '357', name: '357 Days' },
  { value: '358', name: '358 Days' },
  { value: '359', name: '359 Days' },
  { value: '360', name: '360 Days' },
  { value: '361', name: '361 Days' },
  { value: '362', name: '362 Days' },
  { value: '363', name: '363 Days' },
  { value: '364', name: '364 Days' },
  { value: '365', name: '365 Days' },
];

export const CHARITABLE_DONATIONS_IDS = [2292, 2293, 2294, 2295, 2296, 2297];
export const BYP_KIT_IDS = ['2880', '2840'];

export const pendingEzShipOrdersData: { data: PendingEzshipOrdersListResponse } = {
  data: [
    {
      created_date: '2026-03-26T08:15:22Z',
      customerID: 39827,
      firstName: 'Jane',
      lastName: 'Doe',
      autoOrderID: '90019645',
      nextRunDate: '2026-04-10T09:00:00Z',
      pv: '39827',
      amount: '323.32',
      frequency_name: 'Biweekly',
      email: 'jana@pawt',
      phone_number: '555-0101',
      totalCount: 10,
    },
    {
      created_date: '2026-03-27T10:30:45Z',
      customerID: 39828,
      firstName: 'John',
      lastName: 'Doe',
      autoOrderID: '90019646',
      nextRunDate: '2026-04-27T10:30:45Z',
      pv: '41200',
      amount: '450.15',
      frequency_name: 'Monthly',
      email: 'john@pawt',
      phone_number: '555-0102',
      totalCount: 10,
    },
    {
      created_date: '2026-03-28T14:20:10Z',
      customerID: 39829,
      firstName: 'John',
      lastName: 'Smith',
      autoOrderID: '90019647',
      nextRunDate: '2026-04-28T14:20:10Z',
      pv: '25000',
      amount: '210.50',
      frequency_name: 'Monthly',
      email: 'jsmith@pawt',
      phone_number: '555-0103',
      totalCount: 10,
    },
    {
      created_date: '2026-03-29T11:05:33Z',
      customerID: 39830,
      firstName: 'Jane',
      lastName: 'Smith',
      autoOrderID: '90019648',
      nextRunDate: '2026-04-29T11:05:33Z',
      pv: '39827',
      amount: '323.32',
      frequency_name: 'Monthly',
      email: 'janes@pawt',
      phone_number: '555-0104',
      totalCount: 10,
    },
    {
      created_date: '2026-03-30T16:45:12Z',
      customerID: 39831,
      firstName: 'Jane',
      lastName: 'Miller',
      autoOrderID: '90019649',
      nextRunDate: '2026-04-30T16:45:12Z',
      pv: '15400',
      amount: '125.00',
      frequency_name: 'Monthly',
      email: 'jmiller@pawt',
      phone_number: '555-0105',
      totalCount: 10,
    },
    {
      created_date: '2026-03-31T09:12:05Z',
      customerID: 39832,
      firstName: 'John',
      lastName: 'Wilson',
      autoOrderID: '90019650',
      nextRunDate: '2026-05-01T09:12:05Z',
      pv: '39827',
      amount: '323.32',
      frequency_name: 'Monthly',
      email: 'jwilson@pawt',
      phone_number: '555-0106',
      totalCount: 10,
    },
    {
      created_date: '2026-04-01T13:55:29Z',
      customerID: 39833,
      firstName: 'John',
      lastName: 'Brown',
      autoOrderID: '90019651',
      nextRunDate: '2026-05-01T13:55:29Z',
      pv: '50000',
      amount: '599.99',
      frequency_name: 'Monthly',
      email: 'jbrown@pawt',
      phone_number: '555-0107',
      totalCount: 10,
    },
  ],
};
export const PET_VERTICAL_OPTIONS = [
  { value: '1', name: 'Pet Parent/Lover' },
  { value: '2', name: 'Breeder' },
  { value: '3', name: 'Groomer' },
  { value: '4', name: 'Influencer 10k+ Followers' },
  { value: '5', name: 'Pet Sitter/Boarder' },
  { value: '6', name: 'Pet Trainer' },
  { value: '7', name: 'Veterinarian' },
  { value: '8', name: 'Vet Tech' },
  { value: '9', name: '501c3' },
];
